(function () {
    'use strict';

    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-ukpr-signup-trigger]'));

    if (!triggers.length) {
        return;
    }

    // Open Ghost Portal signup dialog
    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            window.location.hash = '#/portal/signup';
        });
    });
}());

(function () {
    'use strict';

    var SIGNUP_URL = 'https://pollingreport.uk/api/v1/signups';
    var modal = document.querySelector('[data-ukpr-signup-modal]');
    var form = document.querySelector('[data-ukpr-email-signup]');
    var status = document.querySelector('[data-ukpr-signup-status]');

    if (!modal || !form) {
        return;
    }

    function getField(id) {
        return document.getElementById(id);
    }

    function getError(id) {
        return document.getElementById(id + '-error');
    }

    function setError(id, message) {
        var field = getField(id);
        var error = getError(id);

        if (field) {
            field.setAttribute('aria-invalid', message ? 'true' : 'false');
        }

        if (error) {
            error.textContent = message || '';
        }
    }

    function clearErrors() {
        ['ukpr-signup-name', 'ukpr-signup-email', 'ukpr-signup-consent'].forEach(function (id) {
            setError(id, '');
        });
    }

    function setCompletedState(isCompleted) {
        form.classList.toggle('is-complete', Boolean(isCompleted));
    }

    function setStatus(message, isError) {
        status.hidden = false;
        status.textContent = message;
        status.className = 'ukpr-email-signup-status' + (isError ? ' is-error' : ' is-success');
    }

    function clearStatus() {
        status.hidden = true;
        status.textContent = '';
        status.className = 'ukpr-email-signup-status';
        setCompletedState(false);
    }

    function openModal() {
        modal.hidden = false;
        document.body.classList.add('ukpr-signup-modal-open');
        window.requestAnimationFrame(function () {
            var firstInput = getField('ukpr-signup-name');
            if (firstInput) {
                firstInput.focus();
            }
        });
    }

    function closeModal() {
        modal.hidden = true;
        document.body.classList.remove('ukpr-signup-modal-open');
        clearErrors();
        clearStatus();
        form.reset();
    }

    function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function validateForm() {
        var name = getField('ukpr-signup-name').value.trim();
        var email = getField('ukpr-signup-email').value.trim();
        var consent = getField('ukpr-signup-consent').checked;
        var valid = true;

        clearErrors();

        if (!name) {
            setError('ukpr-signup-name', 'Your name is required');
            valid = false;
        }

        if (!email) {
            setError('ukpr-signup-email', 'Your email address is required');
            valid = false;
        } else if (!isValidEmail(email)) {
            setError('ukpr-signup-email', 'Your email must be a valid address');
            valid = false;
        }

        if (!consent) {
            setError('ukpr-signup-consent', 'We need your consent to sign up for the newsletter');
            valid = false;
        }

        return valid;
    }

    modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-ukpr-signup-close]')) {
            closeModal();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) {
            closeModal();
        }
    });

    form.addEventListener('submit', function (event) {
        var submitButton;
        var payload;
        var request;

        event.preventDefault();
        clearStatus();

        if (!validateForm()) {
            return;
        }

        submitButton = form.querySelector('.ukpr-email-signup-button');
        payload = JSON.stringify({
            name: getField('ukpr-signup-name').value.trim(),
            email: getField('ukpr-signup-email').value.trim(),
            consent: getField('ukpr-signup-consent').checked
        });

        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';

        request = new XMLHttpRequest();
        request.open('POST', SIGNUP_URL, true);
        request.setRequestHeader('Content-Type', 'application/json');
        request.setRequestHeader('Accept', 'application/json');
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        request.onload = function () {
            var message = 'Something went wrong. Please try again.';
            submitButton.disabled = false;
            submitButton.textContent = 'Submit';

            if (request.status >= 200 && request.status < 300) {
                form.reset();
                clearErrors();
                setCompletedState(true);
                setStatus('Thank you for signing up!', false);
                return;
            }

            try {
                message = JSON.parse(request.responseText).message || message;
            } catch (error) {}

            setStatus(message, true);
        };

        request.onerror = function () {
            submitButton.disabled = false;
            submitButton.textContent = 'Submit';
            setStatus('Network error. Please check your connection and try again.', true);
        };

        request.send(payload);
    });
}());
